import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useOrganization } from "../../context/OrganizationContext";
import styles from "./BillingRequired.module.css";

interface BillingRequiredProps {
  message?: string;
}

const BillingRequired = ({
  message,
}: BillingRequiredProps): React.JSX.Element | null => {
  const { logout } = useAuth();
  const { currentOrg, billingStatus } = useOrganization();
  const navigate = useNavigate();

  // Read the single source of truth computed in OrganizationContext.js
  // (active = isPaid || remaining > 0) instead of re-deriving the negation
  // here — this also matches OrganizationContext's optimistic default
  // (active: true) if this component is ever rendered before the
  // billing-status fetch resolves.
  if (billingStatus?.active) {
    return null;
  }

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className={styles["billing-required-container"]}>
      <div className={styles["billing-required-card"]}>
        <div className={styles["billing-icon"]}>💳</div>

        <h1>Billing Required</h1>

        <div className={styles["org-info"]}>
          <span className={styles["org-name"]}>{currentOrg?.name}</span>
        </div>

        <div className={styles["billing-message"]}>
          {message ||
            "This organization requires active billing to access HallHero."}
        </div>

        <div className={styles["billing-details"]}>
          <h3>What to do:</h3>
          <ul>
            <li>Contact your school administrator to resolve billing</li>
          </ul>
        </div>

        <div className={styles["billing-actions"]}>
          <button className={styles["logout-button"]} onClick={handleLogout}>
            Sign Out
          </button>
        </div>

        <div className={styles["billing-footer"]}>
          <p>For billing inquiries, please contact your school administrator.</p>
        </div>
      </div>
    </div>
  );
};

export default BillingRequired;
